import { preprocess } from '@artica/assets';
import fog from '../common/fog';
import { Color } from 'three';

preprocess('landscape', function preprocessLandscape(gltf) {
  const { materials } = gltf;

  for (const key in materials) {
    if (key === 'default') continue;

    const material = materials[key];

    material.reflectivity = 0.1;
    material.metalness = 0;
    material.roughness = 1;
    material.specularIntensity = 0;
    material.ior = 1.1;
    material.color = new Color(0.2, 0.2, 0.2);

    fog(material);
  }

  gltf.materials.M_Woman_Winter_2.color = new Color(0.1, 0.1, 0.1);

  gltf.materials.Landscape_FG.transparent = true;
  gltf.materials.Landscape_Figure.transparent = true;
  // NOTE: land_snow being transparent has a depth
  // sorting issue with the hero lines, so we're
  // not animating it via opacity
  // gltf.materials.land_snow.transparent = true;
  gltf.materials.land_rocky.transparent = true;
  gltf.materials.Icelandic_Rock_tfiqaftda.transparent = true;

  return gltf;
});